import { defineStore } from 'pinia'
import TagService from '../service/TagService';
const tagService = new TagService();
export const useTagsStore = defineStore({
    id: 'tag',
    state: () => ({
        tags: null,
    }),
    getters: {
        getTags: (state) => {
            return state.tags;
        },
    },
    actions: {
        setTags(tags) {
            this.tags = tags;
        },
        async fetchTags() {
            this.tags = null;
            this.loading = true
            try {
                this.tags = await tagService.fetchTags()
                    .then((response) => response)
            } catch (error) {
                this.error = error
            } finally {
                this.loading = false
            }
        },
        async fetchCreateTag(tag_name) {
            return tagService.fetchCreateTag(tag_name);
        },
        async fetchAssociateTagWithFilters(tag_name, entity, filters) {
            return tagService.fetchAssociateTagWithFilters(tag_name, entity, filters);
        },
        async fetchAssociateTag(tag_name, entity, entity_code) {
            return tagService.fetchAssociateTag(tag_name, entity, entity_code);
        },
        async fetchDisassociateTag(tag_name, entity, entity_code) {
            return tagService.fetchDisassociateTag(tag_name, entity, entity_code);
        },
        async fetchDeleteTag(tag_name) {
            try {
                await tagService.fetchDeleteTag(tag_name)
                    .then((response) => response)
            } catch (error) {
                this.error = error
            }
        }
    }
})